import { MathUtils, Vector2 } from "three";
import { MotionEase2D } from "./utils/motion-ease";
import { gui } from "./utils/gui";
import { VECTOR_ZERO } from "./utils/math";
import TouchControls from "./utils/touch-controls";
import renderer from "./renderer";

export class CameraMovementConfig {
  constructor(
    rotationAxisX = 45,
    rotationAxisY = 25,
    easing = 0.25,
    radius = 15
  ) {
    this.rotationAxis = new Vector2(rotationAxisX, rotationAxisY);
    this.easing = easing;
    this.radius = radius;
  }
}

class CameraMovement {
  constructor() {
    this.gui = gui.addFolder("camera movement");
    // this.gui.open();
    this.rotationMotionEase = new MotionEase2D();
    this.rotationMotionEase.easing = 0.05;
    this.rotationAxis = new Vector2(45, 25);
    this.rotationAxisRadians = new Vector2();
    this.radius = 15;

    this.gui
      .add(this.rotationAxis, "x", 0, 180)
      .onChange(this.onGUIChange)
      .name("rotation x")
      .listen();
    this.gui
      .add(this.rotationAxis, "y", 0, 90)
      .onChange(this.onGUIChange)
      .name("rotation y")
      .listen();
    this.gui
      .add(this.rotationMotionEase, "easing", 0, 1)
      .name("rotation easing")
      .listen();
    this.setRadians();
    this.active = false;
    this.touchControls = new TouchControls(renderer.domElement, {
      touchMove: true,
    });
    this.touchControls.on("mousemove", this.onTouchMove);
  }

  onGUIChange = () => {
    this.setRadians();
  };

  setActive(active) {
    this.active = active;
  }

  setConfig(config) {
    this.rotationAxis.copy(config.rotationAxis);
    this.rotationMotionEase.easing = config.easing;
    this.rotationMotionEase.setValue(0.5, 0.5, false);
    this.radius = config.radius;
    this.setRadians();
  }

  setRadians() {
    this.rotationAxisRadians.x = MathUtils.degToRad(this.rotationAxis.x);
    this.rotationAxisRadians.y = MathUtils.degToRad(this.rotationAxis.y);
  }

  setCamera(camera) {
    this.camera = camera;
  }

  onTouchMove = (data) => {
    this.rotationMotionEase.setValue(data[0].normalX, data[0].normalY, true);
  };

  update() {
    if (!this.active) return;
    this.rotationMotionEase.update();
    const thetaXZ = MathUtils.lerp(
      -this.rotationAxisRadians.x,
      this.rotationAxisRadians.x,
      1.0 - this.rotationMotionEase.value.x
    );
    const thetaY = MathUtils.lerp(
      -this.rotationAxisRadians.y,
      this.rotationAxisRadians.y,
      this.rotationMotionEase.value.y
    );

    this.camera.position.x =
      Math.sin(thetaXZ) * (Math.cos(thetaY) * this.radius);
    this.camera.position.y = Math.sin(thetaY) * this.radius;
    this.camera.position.z =
      Math.cos(thetaXZ) * (Math.cos(thetaY) * this.radius);
    this.camera.lookAt(VECTOR_ZERO);
  }
}

export default new CameraMovement();
